import Vue from 'vue';
import { prepareDisk } from '@/common/store/modules/nodesDisks';
import { DiskRole } from '@schema';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';
import ClusterNotFoundError from '@/common/utils/errors/ClusterNotFoundError';

const getInitialState = () => ({
  disks: { }
});

function prepareConfig({ id, device, role, type, space, service_params: serviceParams, friezed }) {
  const isSystem = [
    DiskRole.CS_SYSTEM,
    DiskRole.MDS_SYSTEM,
    DiskRole.SYSTEM
  ].includes(role);

  return {
    id, device, role, type, space, service_params: serviceParams, friezed, isSystem
  };
}

export default {
  name: 'joinNodeDisks',
  namespaced: true,
  state: getInitialState(),
  getters: {
    getItems: state => nodeId => state.disks[nodeId]?.map(disk => prepareDisk(disk, state.disks[nodeId])) || [],
    getDisksConfig: state => nodeId => state.disks[nodeId].map(disk => prepareConfig(disk))
  },
  mutations: {
    SET(state, { disks, nodeId }) {
      Vue.set(state.disks, nodeId, disks);
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    async FETCH({ commit }, { nodeId }) {
      let clusterId;
      try {
        clusterId = await getClusterId();
      } catch (err) {
        if (err instanceof ClusterNotFoundError) {
          clusterId = null;
        }
      }

      return (clusterId
          ? this.$api.get(`/api/v2/${clusterId}/nodes/${nodeId}/make_join_config/`)
          : this.$api.get('/api/v2/clusters/make_new_cluster_config/', { node_id: nodeId }))
        .then(({ data }) => {
          const { data: disks } = data;
          commit('SET', { disks, nodeId });
        });
    },
    async SET_DISK_CONFIG({ commit }, { nodeId, disks }) {
      let clusterId;
      try {
        clusterId = await getClusterId();
      } catch (err) {
        if (err instanceof ClusterNotFoundError) {
          clusterId = null;
        }
      }

      return (clusterId
          ? this.$api.post(`/api/v2/${clusterId}/nodes/${nodeId}/make_join_config/`, { disks })
          : this.$api.post('/api/v2/clusters/make_new_cluster_config/', { disks, node_id: nodeId }))
        .then(({ data }) => {
          commit('SET', { disks: data.data, nodeId });
        });
    },
    GET_POSSIBLE_ROLES({ getters }, { nodeId, diskIds }) {
      return this.$api.post(`/api/v2/nodes/${nodeId}/disks/make_disks_available_roles/`, {
        disks_to_assign: diskIds,
        disks: getters.getDisksConfig(nodeId)
      });
    }
  }
};
